import * as bootstrap from "bootstrap";

// Initialize Owl Carousel for Services Section
document.addEventListener("DOMContentLoaded", function () {
  // Sticky Navbar on Scroll
  const navbar = document.querySelector(".navbar");
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      navbar.classList.add("navbar-scrolled");
    } else {
      navbar.classList.remove("navbar-scrolled");
    }
  });

  // Wait for jQuery and Owl Carousel to be loaded
  if (typeof jQuery !== "undefined" && jQuery.fn.owlCarousel) {
    jQuery(".services-carousel").owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      dots: false,
      autoplay: true,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      smartSpeed: 1000,
      responsive: {
        0: {
          items: 1,
          nav: false,
        },
        576: {
          items: 1,
          nav: false,
        },
        768: {
          items: 2,
          nav: true,
        },
        992: {
          items: 3,
          nav: true,
        },
        1200: {
          items: 3,
          nav: true,
        },
      },
      navText: [
        '<i class="bi bi-chevron-left"></i>',
        '<i class="bi bi-chevron-right"></i>',
      ],
    });
  } else {
    // Retry if libraries aren't loaded yet
    setTimeout(() => {
      if (typeof jQuery !== "undefined" && jQuery.fn.owlCarousel) {
        jQuery(".services-carousel").owlCarousel({
          loop: true,
          margin: 30,
          nav: true,
          dots: false,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          smartSpeed: 1000,
          responsive: {
            0: {
              items: 1,
              nav: false,
            },
            576: {
              items: 1,
              nav: false,
            },
            768: {
              items: 2,
              nav: true,
            },
            992: {
              items: 3,
              nav: true,
            },
            1200: {
              items: 3,
              nav: true,
            },
          },
          navText: [
            '<i class="bi bi-chevron-left"></i>',
            '<i class="bi bi-chevron-right"></i>',
          ],
        });
      }
    }, 500);
  }

  // Initialize Owl Carousel for Testimonials Section
  function initTestimonialsCarousel() {
    if (typeof jQuery !== "undefined" && jQuery.fn.owlCarousel) {
      jQuery(".testimonials-carousel").owlCarousel({
        loop: true,
        margin: 30,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplayHoverPause: true,
        smartSpeed: 800,
        center: true,
        responsive: {
          0: {
            items: 1,
          },
          576: {
            items: 1,
          },
          768: {
            items: 2,
          },
          992: {
            items: 3,
          },
          1200: {
            items: 3,
          },
        },
      });
    } else {
      setTimeout(initTestimonialsCarousel, 500);
    }
  }

  initTestimonialsCarousel();

  // Appointment Form - WhatsApp Integration
  const appointmentForm = document.getElementById("appointmentForm");
  const othersCheckbox = document.getElementById("service9");
  const othersInput = document.getElementById("others");

  // Show/hide "Others" input field
  if (othersCheckbox && othersInput) {
    othersCheckbox.addEventListener("change", function () {
      if (this.checked) {
        othersInput.style.display = "block";
        othersInput.setAttribute("required", "required");
      } else {
        othersInput.style.display = "none";
        othersInput.removeAttribute("required");
        othersInput.value = "";
      }
    });
  }

  // Handle form submission
  if (appointmentForm) {
    appointmentForm.addEventListener("submit", function (e) {
      e.preventDefault();

      // Get form values
      const name = document.getElementById("name").value.trim();
      const phone = document.getElementById("phone").value.trim();
      const date = document.getElementById("date").value;
      const time = document.getElementById("time").value;
      const maker = document.getElementById("maker").value;
      const model = document.getElementById("model").value;

      // Get selected services
      const serviceCheckboxes = document.querySelectorAll(
        'input[name="services"]:checked'
      );
      const services = Array.from(serviceCheckboxes).map((cb) => cb.value);
      const othersText = document.getElementById("others").value.trim();

      // Build WhatsApp message
      let message = `*New Appointment Request*\n\n`;
      message += `*Contact Information:*\n`;
      message += `Name: ${name}\n`;
      message += `Phone: ${phone}\n`;
      message += `Date: ${date}\n`;
      message += `Time: ${time}\n\n`;
      message += `*Vehicle Details:*\n`;
      message += `Maker: ${maker}\n`;
      message += `Model: ${model}\n\n`;
      message += `*Services Needed:*\n`;

      if (services.length > 0) {
        services.forEach((service, index) => {
          if (service === "Others" && othersText) {
            message += `${index + 1}. ${service}: ${othersText}\n`;
          } else if (service !== "Others") {
            message += `${index + 1}. ${service}\n`;
          }
        });
      } else {
        message += `No services selected\n`;
      }

      // Encode message for URL
      const encodedMessage = encodeURIComponent(message);

      // WhatsApp phone number (replace with your business WhatsApp number)
      // Format: country code + number without +, spaces, or leading 0
      // Examples:
      //   India: 919876543210 (for +91 9876543210)
      //   USA: 15551234567 (for +1 555-123-4567)
      //   UK: 447911123456 (for +44 7911 123456)
      const whatsappNumber = "1234567890"; // ⚠️ CHANGE THIS TO YOUR WHATSAPP NUMBER

      // Create WhatsApp URL
      const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

      // Open WhatsApp in new tab
      window.open(whatsappURL, "_blank");

      // Optional: Show success message
      const submitButton = appointmentForm.querySelector('button[type="submit"]');
      const originalText = submitButton.innerHTML;
      submitButton.innerHTML = '<i class="bi bi-check-circle me-2"></i>Opening WhatsApp...';
      submitButton.disabled = true;

      setTimeout(() => {
        submitButton.innerHTML = originalText;
        submitButton.disabled = false;
        // Optional: Reset form
        // appointmentForm.reset();
      }, 2000);
    });
  }

  // Formspree Integration for Appointment Form
  var form = document.getElementById("my-form");
  if (form) {
    async function handleSubmit(event) {
      event.preventDefault();
      var status = document.getElementById("my-form-status");
      var data = new FormData(event.target);
      status.innerHTML = "Sending...";
      
      fetch(event.target.action, {
        method: form.method,
        body: data,
        headers: {
          'Accept': 'application/json'
        }
      }).then(response => {
        if (response.ok) {
          form.style.display = "none";
          document.getElementById("form-success-wrapper").style.display = "block";
          form.reset();
        } else {
          response.json().then(data => {
            if (Object.hasOwn(data, 'errors')) {
              status.innerHTML = data["errors"].map(error => error["message"]).join(", ");
            } else {
              status.innerHTML = "Oops! There was a problem submitting your form";
            }
          });
        }
      }).catch(error => {
        status.innerHTML = "Oops! There was a problem submitting your form";
      });
    }
    form.addEventListener("submit", handleSubmit);
  }
});
